export default "__VITE_ASSET__DDCbFhH___"